import { useState } from "react"

import { useTranslation } from "react-i18next"

import { PromotionEditorPage } from "components/promotions/PromotionEditorPage"

import { Promotions } from "views/Promotions"

import { InfoBox } from "../CmsUi"

/** Which promotion the tab is editing, if any. `null` shows the list. */
type Editing = { mode: "create" } | { mode: "edit"; id: string } | null

/** Pages, not banners: each is server-rendered at its own URL and appears in the sitemap. */
export function PromotionsTab() {
  const { t } = useTranslation("translation", { useSuspense: false })
  const [editing, setEditing] = useState<Editing>(null)
  const [listVersion, setListVersion] = useState(0)

  const close = () => setEditing(null)

  // Editing happens here rather than on the standalone screen, so an editor
  // never loses the CMS Pages view they started from.
  if (editing) {
    return (
      <div className="flex flex-col gap-5 p-4 sm:p-5">
        <PromotionEditorPage
          embedded
          mode={editing.mode}
          id={editing.mode === "edit" ? editing.id : undefined}
          onSaved={() => {
            setListVersion((version) => version + 1)
            close()
          }}
          onCancel={close}
        />
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-5 p-4 sm:p-5">
      <InfoBox>
        {t("cmsSeo.promotionsInfo", {
          defaultValue:
            "Promotions and news are server-rendered at /promotions/<slug> and /news/<slug>, and appear in the articles sitemap. An article whose run has ended resolves to noindex and drops out of it."
        })}
      </InfoBox>

      <Promotions key={listVersion} onCreate={() => setEditing({ mode: "create" })} onOpen={(id) => setEditing({ mode: "edit", id })} />
    </div>
  )
}
